import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <section className="py-12 px-4 text-center bg-gradient-to-r from-[#202c45] to-[#3f5c8f]">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to start your STEM journey?
        </h2>
        <p className="text-white text-lg max-w-2xl mx-auto mb-8">
          Join our community of young innovators and build the skills needed for future success.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a 
            href="https://docs.google.com/forms/d/e/1FAIpQLSfcR5SGMKi9XrdgFROEUukUL5oINfiQQy-cnezcsjt0KbSHOQ/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-3 bg-gradient-to-r from-[#2046b3] to-[#2d6af6] text-white font-medium rounded-full hover:from-[#2d6af6] hover:to-[#2046b3] transition-colors shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
          >
            Apply for a Course
          </a>
          <Link 
            to="/contact"
            className="px-8 py-3 bg-white text-blue-600 font-medium rounded-full hover:bg-gray-100 transition-colors"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CallToAction; 